import { type FileSaverOptions, saveAs } from 'file-saver';

export class FileUtils {
  static downloadFile = (data: Blob | string, filename?: string, options?: FileSaverOptions) => saveAs(data, filename, options);
}
